<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <popup-header @clickClose="closeModal()" :headerBg="'grey'" />

    <v-container class="bg-grey app-wrapper">
      <!-- 제목 -->
      <v-row class="title-wrap app">
        <v-col
          cols="12"
          class="icon-title word-type d-flex justify-space-between"
        >
          <span>
            <!-- 신청서에 따라 아이콘 변경 -->
            <appl-menu-icon
              :propsParam="{
                applCd: appInfoParam.applCd,
                gntGubunCd: appInfoParam.gubunCd,
              }"
              :styleClassStr="'mr-0'"
            ></appl-menu-icon>
            {{
              isCerti
                ? appInfoParam.applNm + '신청서'
                : appInfoParam.applNm + '서'
            }}
          </span>
          <!-- 재사용 버튼 (개발예정) -->
          <!-- <v-btn elevation="0" color="#e1e3e5" height="38" class="btn-reuse"
            ><v-icon size="16" class="mr-1">mdi-clipboard-text-outline</v-icon
            >재사용</v-btn
          > -->
        </v-col>
      </v-row>

      <!-- 내용 -->
      <v-row class="mt-0 overflow-y-auto" :style="scrollViewStyle">
        <v-col cols="12" class="pt-3 px-6 pb-10">
          <!-- 신청서 시작 -->
          <v-card
            class="mx-auto card-box"
            elevation="0"
            v-show="!GET_APP_LOADING_STATUS"
          >
            <!-- 신청서 내용 (스피너 OFF시 노출) -->
            <v-list class="card-contents">
              <!-- 근태,보상,근태취소,보상취소 -->
              <vacation-viewer-data
                v-if="
                  appInfoParam.applCd === '22' ||
                  appInfoParam.applCd === '42' ||
                  appInfoParam.applCd === '23' ||
                  appInfoParam.applCd === '43'
                "
                :appInfoParam="appInfoParam"
                @showCancelApplBtn="showCancelApplBtn"
                @hideCancelApplBtn="hideCancelApplBtn"
              />
              <!-- 연장근무신청 -->
              <ot-work-viewer-data
                v-if="appInfoParam.applCd === '110'"
                :appInfoParam="appInfoParam"
              />
              <!-- 근무스케줄신청 -->
              <schedule-viewer-data
                v-if="appInfoParam.applCd === '301'"
                :appInfoParam="appInfoParam"
              />
              <!-- 출퇴근변경신청 -->
              <attend-viewer-data
                v-if="appInfoParam.applCd === '30'"
                :appInfoParam="appInfoParam"
              />
              <!-- 제증명신청 -->
              <certi-viewer-data v-if="isCerti" :appInfoParam="appInfoParam" />

              <!-- 출장신청 -->
              <biz-trip-viewer-data
                v-if="isBizTrip"
                :appInfoParam="appInfoParam"
              />
            </v-list>
          </v-card>

          <!-- 신청서별 추가정보 -->
          <!-- * 출장신청서 동행인목록 -->
          <biz-trip-joiner-line v-if="isBizTrip && !GET_APP_LOADING_STATUS" />

          <!-- 그외 공통정보 (결재라인, 첨부파일) -->
          <v-expansion-panels
            v-show="!GET_APP_LOADING_STATUS"
            v-model="panelArray"
            multiple
          >
            <appl-panel>
              <span slot="title">결재자</span>
              <appl-line slot="component" />
            </appl-panel>
            <appl-panel>
              <span slot="title">첨부파일</span>
              <attach-file slot="component" />
            </appl-panel>
            <appl-panel>
              <span slot="title">담당자</span>
              <mgr-line slot="component" />
            </appl-panel>

            <appl-panel v-if="GET_UI_INFO.referYn === 'Y'">
              <span slot="title">참조자</span>
              <refer-line slot="component" />
            </appl-panel>
          </v-expansion-panels>

          <!-- 신청서 뷰어 스켈레톤 로더 -->
          <viewer-skeleton-loader v-show="GET_APP_LOADING_STATUS" />
        </v-col>
      </v-row>
    </v-container>

    <!-- 반려 / 결재버튼 -->
    <v-bottom-navigation
      fixed
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500"
      height="96"
      v-if="isApprDocViewer"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="6" class="py-0 pl-0 pr-2">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-red"
            @click="openRejectReasonModal()"
          >
            <span class="white--text">반려</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="py-0 pl-2 pr-0">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applConfirm()"
          >
            <span class="white--text">결재</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

    <!-- 취소신청 버튼 -->
    <viewer-bottom-btn
      v-if="cancelBtnShow && GET_APPL_MENU_USE_YN"
      :btnName="'취소 신청하기'"
      @clickBtn="applCancel()"
    />

    <!-- 회수하기 버튼 -->
    <viewer-bottom-btn
      v-if="isApplInProgress"
      :btnName="'회수하기'"
      @clickBtn="applWithdraw()"
    />

    <!-- 반려 사유 모달 -->
    <reject-reason-dialog @reject="applReject" />
  </v-dialog>
</template>

<script>
/* 신청서뷰어모달 */
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import VacationViewerData from '@/components/application/viewer/VacationViewerData.vue';
import OtWorkViewerData from '@/components/application/viewer/OtWorkViewerData.vue';
import ScheduleViewerData from '@/components/application/viewer/ScheduleViewerData.vue';
import AttendViewerData from '@/components/application/viewer/AttendViewerData.vue';
import BizTripViewerData from '@/components/application/viewer/BizTripViewerData.vue';
import CertiViewerData from '@/components/application/viewer/CertiViewerData.vue';
import AttachFile from '@/components/application/form/AttachFile.vue';
import ApplLine from '@/components/application/form/ApplLine.vue';
import ReferLine from '@/components/application/form/ReferLine.vue';
import ApplPanel from '@/components/application/form/ApplPanel.vue';
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component
import ViewerSkeletonLoader from '@/components/application/viewer/ViewerSkeletonLoader.vue';
import MgrLine from '@/components/application/form/MgrLine.vue';
import BizTripJoinerLine from '@/components/application/form/BizTripJoinerLine.vue';

import ViewerBottomBtn from '@/components/application/buttons/ViewerBottomBtn.vue';
import RejectReasonDialog from '@/components/application/dialog/RejectReasonDialog.vue';

import { postApplCancel, postApplConfirm, postApplReject } from '@/api/ela';
import { deleteApplication } from '@/api/application';

import { mapGetters, mapMutations } from 'vuex';
import viewerMixin from '@/mixins/viewerMixin.js';
import dialogMixin from '@/mixins/dialogMixin.js';
import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';

export default {
  mixins: [viewerMixin, dialogMixin],

  data: () => ({
    appViewData: [],
    modalName: 'application_viewer',
    cancelBtnShow: false,
    // 취소신청용
    alterVacationInfo: {},
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_OBJ']),
    ...mapGetters('DIALOG', ['GET_DIALOG_PARAM']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),
    ...mapGetters('ELA', [
      'GET_ELA_APPL_PARAM',
      'GET_SEARCH_APPL_CD',
      'GET_SEARCH_APPL_SEQ',
      'GET_FILE_LIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
    ]),

    isCerti() {
      return (
        this.appInfoParam.applCd === applCode.EmpCerti ||
        this.appInfoParam.applCd === applCode.EmpCertiEn ||
        this.appInfoParam.applCd === applCode.CareerCerti ||
        this.appInfoParam.applCd === applCode.CareerCertiEn
      );
    },

    panelArray() {
      let panel = [0];
      if (this.GET_FILE_LIST.length > 0) panel.push(1);
      if (this.GET_MGR_USER_LIST.length > 0) panel.push(2);
      if (
        this.GET_UI_INFO.referYn === 'Y' &&
        this.GET_REFER_USER_LIST.length > 0
      )
        panel.push(3);
      return panel;
    },
    appInfoParam() {
      return this.GET_DIALOG_PARAM;
    },
    // 결재처리중인지
    isApplInProgress() {
      return (
        (!this.isApprDocViewer && // 결재함아니고
          !this.isReferBoxViewer && // 참조함아니고
          this.appInfoParam.applStatusCd === '21') ||
        false
      );
    },
    /* 버튼유무에 따른 스크롤 높이 제어 */
    scrollViewStyle() {
      if (
        this.isApprDocViewer ||
        this.isApprDocViewer ||
        (this.cancelBtnShow && this.GET_APPL_MENU_USE_YN) ||
        this.isApplInProgress
      ) {
        return `max-height: ${
          window.innerHeight - this.vt_header_title_button
        }px`;
      } else {
        return `max-height: ${window.innerHeight - this.vt_header_title}px`;
      }
    },
  },

  watch: {
    appInfoParam() {
      this.SET_FILE_LIST([]);
      // 신청서 기본정보 조회
      this.fetchAppInfo();
      // 취소신청 버튼 일단 숨김 처리
      this.hideCancelApplBtn();
    },
  },

  methods: {
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP', 'SET_GNT_GUBUN_TMP']),
    ...mapMutations('ELA', [
      'SET_FILE_LIST',
      'SET_APP_MAP_DATA',
      'SET_GNT_CD',
      'SET_HALF_YN',
      'SET_ALTER_VACATION',
      'SET_APP_MENU',
      'SET_CLOSE_DAY',
      'SET_CLOSE_DAY_DATA',
      'SET_VACATION_STATE',
      'SET_SEARCH_BF_APPL_SEQ',
    ]),
    ...mapMutations('SPINNER', ['ON_COMMON_SPINNER', 'OFF_COMMON_SPINNER']),

    /* 신청 상세 기본 정보 조회 */
    async fetchAppInfo() {
      const initParams = {
        searchApplCd: this.appInfoParam.applCd,
        adminYn: 'N',
        authPg: 'R',
        searchApplSeq: this.appInfoParam.applSeq,
        searchApplSabun: this.appInfoParam.applSabun,
        searchApplInSabun: this.appInfoParam.applInSabun,
        searchApplStatusCd: this.isApplConfirmViewer
          ? '21'
          : this.appInfoParam.applStatusCd,
      };

      try {
        this.ON_APP_SPINNER(); // 스피너 ON
        await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);
        await this.$store.dispatch('ELA/FETCH_FILE_LIST');
        // * 각 신청서 component에서 조회 후 스피너 OFF 예정
      } catch (error) {
        alert(error);
        this.OFF_APP_SPINNER(); // 스피너 OFF
      }
    },

    /* 취소신청시 */
    async applCancel() {
      // 취소신청 코드
      let searchApplCd = '';
      if (this.appInfoParam.applCd === '22') searchApplCd = '23';
      if (this.appInfoParam.applCd === '42') searchApplCd = '43';
      if (searchApplCd === '') return false;

      const initParams = {
        searchApplCd,
        adminYn: 'N',
        authPg: 'A',
        etc01: this.appInfoParam.applSeq,
        searchApplSeq: '',
        searchApplSabun: this.appInfoParam.applSabun,
        searchApplInSabun: this.appInfoParam.applInSabun,
      };

      try {
        // 취소 신청 기본정보 조회
        await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', initParams);

        // 추가 옵션 화면 조회시 필요 데이터 세팅
        this.SET_APP_MENU({ applCd: searchApplCd });
        this.SET_SEARCH_BF_APPL_SEQ(this.appInfoParam.applSeq);
        this.SET_VACATION_STATE(this.GET_APP_MAP_DATA);
        this.SET_GNT_CD(this.GET_GNT_CD_OBJ);
        this.SET_HALF_YN();
        this.SET_CLOSE_DAY_DATA(this.GET_APP_MAP_DATA.closeDay);
        this.toggleModal();
        // 추가옵션 화면으로 바로 이동
        this.$router.push(routerNames.ExtraOptions);
      } catch (error) {
        alert(error);
      }
    },

    /* 회수 + 삭제 */
    async applWithdraw() {
      if (confirm('신청서를 회수하시겠습니까?')) {
        const applSeq = this.appInfoParam.applSeq.toString();
        const applCd = this.appInfoParam.applCd;

        try {
          // 회수처리
          const response = await postApplCancel({
            searchApplSeq: applSeq,
          });
          const resultCnt = response.data.data.cnt;

          // 회수 성공시 삭제처리
          if (resultCnt === 1) {
            // ** 제증명, 출장신청은 회수 후처리가 없음
            if (this.isCerti || this.isBizTrip) {
              this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
              alert('신청서 회수가 완료되었습니다.');
              this.closeModal();
              return;
            }

            const deleteRows = [];
            if (applCd === '23' || applCd === '43') {
              deleteRows.push({ applSeq2: applSeq });
            } else {
              deleteRows.push({ applSeq });
            }

            let deleteResponse = await deleteApplication(applCd, {
              deleteRows,
            });
            const resultData = deleteResponse.data.data;

            if (resultData === 1) {
              this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
              alert('신청서 회수가 완료되었습니다.');
              this.closeModal();
            } else {
              alert(
                '신청서 회수가 완료되었습니다. 워크업 웹사이트에서 삭제처리를 해주세요.',
              );
            }
            return false;
          } else {
            alert('회수에 실패했습니다. 잠시 후 다시 시도해주세요.');
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    /* 결재 */
    async applConfirm() {
      if (!confirm('결재하시겠습니까?')) return false;
      this.ON_COMMON_SPINNER(); // 공통 스피너 ON

      try {
        const param = {
          searchApplSabun: this.appInfoParam.applSabun,
          searchApplSeq: this.appInfoParam.applSeq.toString(),
          searchApplCd: this.appInfoParam.applCd,
          agreeSeq: this.appInfoParam.agreeSeq.toString(),
          agreeGubun: this.appInfoParam.agreeGubun,
        };

        const response = await postApplConfirm(param);

        if (response == null || response.data.data.cnt < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
          alert('결재 되었습니다.');
          this.closeModal();
        }

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /* 반려사유 입력 모달 오픈 */
    openRejectReasonModal() {
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'reject_reason');
    },

    /* 반려 */
    async applReject(agreeUserMemo) {
      this.ON_COMMON_SPINNER(); // 공통 스피너 ON
      try {
        const param = {
          searchApplSabun: this.appInfoParam.applSabun,
          searchApplSeq: this.appInfoParam.applSeq.toString(),
          searchApplCd: this.appInfoParam.applCd,
          agreeSeq: this.appInfoParam.agreeSeq.toString(),
          agreeGubun: this.appInfoParam.agreeGubun,
          agreeUserMemo,
        };
        const response = await postApplReject(param);
        if (response == null || response.data.data.cnt < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
          alert('반려 되었습니다.');
          this.closeModal();
        }
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /** 취소신청 버튼 제어 */
    showCancelApplBtn() {
      this.cancelBtnShow = true;
    },
    hideCancelApplBtn() {
      this.cancelBtnShow = false;
    },
  },

  components: {
    VacationViewerData,
    OtWorkViewerData,
    ScheduleViewerData,
    AttendViewerData,
    BizTripViewerData,
    CertiViewerData,
    AttachFile,
    ApplLine,
    ReferLine,
    ApplMenuIcon,
    PopupHeader,
    ApplPanel,
    ViewerBottomBtn,
    RejectReasonDialog,
    ViewerSkeletonLoader,
    MgrLine,
    BizTripJoinerLine,
  },
};
</script>
<style scoped>
/* application.scss 참고 */
</style>
